/**
 * Persona status.
 * Should mimic the backend since we don't want to rely on the SDK types here.
 */
export enum PersonaAvailability {
  Away = 'away',
  Busy = 'busy',
  Offline = 'offline',
  Online = 'online',
  Unknown = 'unknown'
}
